/**
 * Media-proxy URL resolution. Stored image URLs may be server-relative proxy paths
 * (`/api/media/...`) so documents stay environment-agnostic. Web serves the app and the API
 * from the same origin (Hosting rewrites `/api/**` to Cloud Run; Vite proxies it in dev), so
 * relative paths work untouched. Native shells load images by absolute URL, so the platform
 * bootstrap injects its API base here (FeaturesContainer wires the flow base URL).
 */

let mediaBaseUrl = '';

/** Injected at composition time; empty (same-origin) is the web default. */
export function setMediaBaseUrl(base: string | undefined): void {
  mediaBaseUrl = (base ?? '').replace(/\/+$/, '');
}

/** Resolves a stored image URL for the current platform. Absolute URLs pass through untouched. */
export function resolveMediaUrl(url: string): string {
  if (mediaBaseUrl && url.startsWith('/api/')) {
    return `${mediaBaseUrl}${url}`;
  }
  return url;
}
